// extracted by mini-css-extract-plugin
export default {"title":"PortfolioPage_title__2+T20"};